// extracted by mini-css-extract-plugin
export default {"inlineCheckbox":"RzLx9RYPcTOymntpbX3H"};